import * as React from 'react';
import { useGetThicknessClassQuery } from "../../../apis/ThicknessClass.api";
import { PrimaryThicknessClass, ThicknessClass } from "../../../types/models/ThicknessClass";
import TimberClassName from "../../../../timber/components/timberClass/TimberClassDetail/TimberClassName";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: ThicknessClass;
};

export const ThicknessClassNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.name }
                    {data?.classId && <> | </> }<TimberClassName id={ data?.classId }/>
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const ThicknessClassName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetThicknessClassQuery(PrimaryThicknessClass.fromId(id))
    return (<ThicknessClassNameDisplay data={data}/>)
}

export default ThicknessClassName;
